<!-- Container with dynamic margin-bottom -->
<div class="display-container">
  <!-- Only show label if it exists -->
  <label *ngIf="label">{{ label }}</label>

  <!-- If there is no custom valueComponent, just show the text value -->
  <span *ngIf="!valueComponent">
    {{ value || '-' }}
  </span>

  <!-- If valueComponent is provided as an HTML string, render it -->
  <div *ngIf="valueComponent" [innerHTML]="valueComponent"></div>
</div>
